<template>
  <!-- <div class="fixed left-0 top-0 z-20 w-full p-[10px] bg-[#2459A8]">
    <div class="container !max-w-full laptop:!max-w-[1200px] largeDesktop:!max-w-[1600px]">
      <div class="flex items-center justify-center">
        <a @click="logoClicked()" class="w-[120px] h-[60px] laptop:w-[155px] laptop:h-[70px] cursor-pointer">
          <img src="../../../assets/images/myHappyHomeLogo.svg" alt="Logo" class="w-full h-full object-contain">
        </a>
      </div>
    </div>
  </div> -->
  <NewHeader />
</template>

<script>
import NewHeader from './header.vue';
export default {
  components: {
    NewHeader
  },
  methods: {
    logoClicked() {
      window.location = process.env.VUE_APP_HOME_PAGE_URL
    },
  }
};
</script>